import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IAdminInsightsResult } from '../types/IAdminInsightsResult';

export class AdminInsightsGetProjectIdRequest
    extends Request<{},IAdminInsightsResult> {

    constructor() {
        super('getAdminInsightsProjectId', {});
    }
}
